module.exports = require("/app/mui-root-wrapper")